import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";
import { readURIParams } from "@flixbus-phx/marketplace-common";
import { useSearchParams } from "react-router-dom";
import addGetParams from "../../shared/helpers/addGetParams/addGetParams";
import { SortDirection, SortField } from "../../shared/types/schema";

export type RideSort = {
  field: SortField;
  direction: SortDirection;
};

export const getSortField = (): SortField => {
  const { sortBy } = readURIParams(window.location.search);
  if (sortBy && Object.values(SortField).includes(sortBy as SortField)) {
    return sortBy as SortField;
  }
  return SortField.Departure;
};

export const getSortDirection = (): SortDirection => {
  const { sort } = readURIParams(window.location.search);

  if (sort && Object.values(SortDirection).includes(sort as SortDirection)) {
    return sort as SortDirection;
  }
  return SortDirection.Asc;
};

export const rideSortVar = makeVar<RideSort>({
  field: getSortField(),
  direction: getSortDirection(),
});

const useRideSort = (reactiveVar: ReactiveVar<RideSort>): [RideSort, (changedRideSortValues: RideSort) => void] => {
  const rideSort = useReactiveVar(reactiveVar);
  const [searchParams, setSearchParams] = useSearchParams();

  const setParams = (changedRideSortValues: RideSort) => {
    addGetParams(
      {
        sortBy: changedRideSortValues.field,
        sort: changedRideSortValues.direction,
      },
      searchParams
    );
    setSearchParams(searchParams);
  };

  const setRideSort = (changedRideSortValues: RideSort) => {
    reactiveVar({
      ...changedRideSortValues,
    });
    setParams(changedRideSortValues);
  };

  return [rideSort, setRideSort];
};

export default useRideSort;
